import { Button, Flex, Typography } from "antd";
import { type ElementType, type ReactNode, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import "./Error.scss";

type Props = {
  titleIntlKey: string;
  descriptionIntlKey: string;
  actionButtonIntlKey: string;
  onActionButtonClick?: () => void;
  details?: ReactNode;
  Icon: ElementType;
}

const ErrorView = ({ titleIntlKey, descriptionIntlKey, actionButtonIntlKey, onActionButtonClick, details, Icon }: Props) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { sport, customerId, organizationId } = useParams();

  const handleBack = useCallback(() => {
    const back = state?.back;
    if (back) {
      navigate(back);
    } else if (customerId && sport && organizationId) {
      navigate(`/${customerId}/admin/${sport}/${organizationId}/admin`);
    } else if (customerId) {
      navigate(`/${customerId}/select/organization`);
    } else {
      navigate("/");
    }
  }, [state?.back, navigate, customerId, sport, organizationId]);

  return (
    <Flex justify="center" align="center" className="error-wrapper">
      <Flex vertical align="center">
        <Flex justify="center" align="center" gap={16}>
          <Icon />
          <Typography.Title level={4}>
            <FormattedMessage id={titleIntlKey}/>
          </Typography.Title>
        </Flex>
        <Typography.Text>
          <FormattedMessage id={descriptionIntlKey} />
        </Typography.Text>
        <Button onClick={onActionButtonClick || handleBack} className="error-action-button">
          <FormattedMessage id={actionButtonIntlKey} />
        </Button>
        {details && <div className="error-details-wrapper">{details}</div>}
      </Flex>
    </Flex>
  );
};

export default ErrorView;
